import { Link } from 'gatsby';
import * as React from 'react';

const CREATURE_CHESS_URL = "https://creaturechess.gg";

const Layout = ({ children }: { children: React.ReactNode }) => (
    <div className="min-h-screen flex flex-col">
        <nav className="bg-gray-700 p-3 text-white font-sans shadow">
            <header className="flex justify-between items-center mx-auto md:max-w-3xl">
                <a className="text-2xl tracking-widest" href="/">jkm<span className="px-2 bg-slate-500 hover:bg-pink-500 transition duration-200">.dev</span></a>
                <nav className="flex space-x-4">
                    <a
                        className="font-bold text-pink-500 hover:text-pink-400 hover:underline border-r border-r-2 border-pink-500 pr-4"
                        href={CREATURE_CHESS_URL}
                        target="_blank"
                    >Play Creature Chess</a>
                    <Link to="/projects" className="hover:underline">Projects</Link>
                </nav>
            </header>
        </nav>
        <main className="mb-16 py-8 px-4 flex-grow container mx-auto md:max-w-3xl">
            {children}
        </main>
        <footer className="p-8 text-gray-800 border-t-2 border-dashed border-gray-700">
    <section className="mx-auto md:max-w-3xl grid md:grid-cols-3 grid-cols-1 gap-4">
        <div className="md:col-span-2 bg-gray-300 p-4 text-center text-gray-800 rounded shadow">
            <section className="my-4">
                <h2 className="mb-3 text-2xl">Like my blog? Try my game!</h2>
                <p><span className="text-pink-500 font-bold text-xl">Creature Chess</span> is a lofi chess battler</p>
                <p>It's free, you can play it from your browser, and a game takes 10 minutes</p>
                <a className="transition duration-200 mt-3 inline-block py-4 px-4 bg-pink-500 hover:bg-pink-400 hover:underline text-white font-bold rounded" href={CREATURE_CHESS_URL} target="_blank">Play Creature Chess</a>
            </section>
            <div className="flex space-x-4 justify-center flex-wrap">
                <img src="https://d1og15z2t89fge.cloudfront.net/creatures/front/45.png" />
                <img src="https://d1og15z2t89fge.cloudfront.net/creatures/front/17.png" />
                <img src="https://d1og15z2t89fge.cloudfront.net/creatures/front/47.png" />
                <img src="https://d1og15z2t89fge.cloudfront.net/creatures/front/30.png" />
                <img src="https://d1og15z2t89fge.cloudfront.net/creatures/front/13.png" />
            </div>
        </div>
        <div className="flex items-center justify-end text-right">
            <p>Find my other work on <a href="https://github.com/jameskmonger" className="whitespace-nowrap text-blue-500 hover:text-blue-700" target="_blank" rel="noopener noreferrer">Github @jameskmonger</a></p>
        </div>
    </section>
</footer>

    </div>
);

export default Layout;
